import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer, Buttons, Spinner, Modals, ModalContext } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import SliderComponent from './SliderComponent';
import CommentComponent from './CommentComponent';
import { useSaveUserReview } from './hooks';

const ReviewModal = (): JSX.Element => {
  const { hideModal } = useContext(ModalContext);
  const [comment, setComment] = useState<string>('');
  const [rating, setRating] = useState<number>();
  const { mutate, isLoading } = useSaveUserReview(hideModal);
  const tax = useSelector(taxSelectedSelector);
  const { t } = useTranslation(locizeNS.MODALS);

  const handleClick = (value: string): void => {
    setComment(value);
  };

  const handleSetRating = (value: number): void => {
    setRating(value);
  };

  const handleClickShareModal = (): void => {
    if ((rating && tax?.taxYear) || (rating === 0 && tax?.taxYear)) {
      mutate({
        taxYear: tax.taxYear.toString(),
        comment,
        rating,
      });
    }
  };

  const enableButton = (rating && rating >= 0 && rating <= 10) || rating === 0;

  return (
    <Modals.Centered maxSize="M" hasClose={false}>
      <FlexContainer direction="column">
        <FlexContainer direction="column" gap="dimension_16" align="center" justify="center">
          <SliderComponent onClick={handleSetRating} />
          <CommentComponent comment={comment} onClick={handleClick} />
          {isLoading ? (
            <Spinner size="M" justify="center" align="center" />
          ) : (
            <Buttons.Classic
              label={!isLoading ? t('Declaration.send') : ''}
              mode="primary"
              size="m"
              disabled={!enableButton}
              onClick={handleClickShareModal}
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </Modals.Centered>
  );
};

export default ReviewModal;
